module.exports = function defaults(v, fallback) {
  return v == null ? fallback : v
}
